// @ts-nocheck


import React from 'react';
import styled from 'styled-components';
import { RangePicker } from '../../../components/ant/DatePicker';
import moment from 'moment';

import { Card, FilterButtonsContainer, Selects } from './../../../components';
import OrgUnitSelect from './../../../components/OrgUnitSelect';
import { formatDateTimeToISOString } from './../../../lib/helpers';

import { Filter } from '../../../components/hoc';

import FilterContainer from '../../../components/hoc/FilterContainer';
import FilterItem from '../../../components/hoc/FilterItem';

const { Field } = Card;
const { VehicleSelect, VehicleTypeSelect } = Selects;

const Content = styled.div.withConfig({ displayName: "Filter__Content", componentId: "sc-1sxnw0y-0" })(["padding:16px;"]);





















const TripFilter = ({ style, filter, applyFilter, cleanFilter }) =>
<Content style={{ ...style }}>
    <FilterContainer>
      <Filter
      initialValues={filter}
      applyFilter={applyFilter}
      cleanFilter={cleanFilter}
      additionalFilter>

        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter,
        showAdditional,
        handleAdditional
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <VehicleTypeSelect
              size="small"
              placeholder="Все типы ТС"
              value={values['vehicle.vehicleModel.type']}
              selectableGroup
              onChange={(value) =>
              changeValue('vehicle.vehicleModel.type', value)
              } />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker
              format="DD.MM.YYYY HH:mm"
              showTime={{
                format: 'HH:mm',
                defaultValue: [
                moment('00:00', 'HH:mm'),
                moment('23:59', 'HH:mm')]

              }}
              size="small"
              placeholder={['Начало', 'Конец']}
              value={[
              values.startDate ? moment.utc(values.startDate) : null,
              values.endDate ? moment.utc(values.endDate) : null]
              }
              onChange={(value, dateString) => {
                const [startDate, endDate] = value;
                const [startDateString, endDateString] = dateString;
                changeValue(
                  'startDate',
                  formatDateTimeToISOString(startDate, startDateString) ||
                  undefined
                );
                changeValue(
                  'endDate',
                  formatDateTimeToISOString(endDate, endDateString) ||
                  undefined
                );
              }} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <VehicleSelect
              placeholder="По всем ТС"
              size="small"
              value={values['vehicle.id']}
              onChange={(value) => changeValue('vehicle.id', value)} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <OrgUnitSelect
              size="small"
              placeholder="Все подразделения"
              onChange={(value) => changeValue('vehicle.usingNodeId', value)}
              value={values['vehicle.usingNodeId']} />

              </Field>
            </FilterItem>
            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter}
          handleAdditional={handleAdditional}
          showAdditional={showAdditional} />

          </>
      }
      </Filter>
    </FilterContainer>
  </Content>;


export default TripFilter;